import React, { Component } from "react";
import { observer } from "mobx-react";
import hot from "../../static/images/hotbg.png";
import kuaizhuang from "../../static/images/kuaizhuang.png";
import nosearch from "../../static/images/gantanhao.png";
import searc_in from "../../static/images/searc_in.png";
import { ListView } from "antd-mobile";
import "./index.css";
import { findByQuestionPageable } from "../../static/js/http";
import home from "../../store/index";
import Loading from "../Loading/index";
import Modal from "../Modal";
@observer
class Search extends Component {
  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2, // rowHasChanged(prevRowData, nextRowData); 用其进行数据变更的比较
    });
    this.state = {
      value: "",
      dataSource,
      datas: [],
      page: 0,
      size: 12,
      hasMore: true,
      refreshing: true,
      isLoading: true,
      dataArr: [],
      showId: "0",
      totalElements: 0,
      totalPages: 0,
      tags: JSON.parse(sessionStorage.getItem("tags")),
      showDetail: false,
      selectData: {},
      showTag: false,
      isSearch: false,
      count: 1,
    };
  }
  componentDidMount() {
    home.selectTag("");
    home.HotAll();
  }
  getData() {
    let params = {
      page: this.state.page,
      size: this.state.size,
      question: this.state.value,
      type: 3,
    };
    findByQuestionPageable(params)
      .then((res) => {
        if (res.msg === "success") {
          let data = res.data.pageData.filter(
            (item) => item.storeQuestionEntity.isShow
          );
          let dataArr = this.state.dataArr.concat(data);
          this.setState({
            dataArr: dataArr,
            hasMore: true,
            refreshing: true,
            isLoading: false,
            dataSource: this.state.dataSource.cloneWithRows(dataArr),
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages,
          });
          setTimeout(() => {
            home.isLoading = false;
          }, 1200);
        }
      })
      .catch((err) => {});
  }
  serarchK(e) {
    if (e !== "") {
      if (e.target.value !== "") {
        home.serchKeyWords(e.target.value);
        this.setState(
          {
            value: e.target.value,
            page: 0,
            dataArr: [],
            dataSource: this.state.dataSource.cloneWithRows([]),
            totalElements: 0,
            totalPages: 0,
            isSearch: true,
          },
          () => {
            this.OnceShearch();
          }
        );
      } else {
        this.setState({
          value: e.target.value,
          page: 0,
          dataArr: [],
          dataSource: this.state.dataSource.cloneWithRows([]),
          totalElements: 0,
          totalPages: 0,
          isSearch: false,
        });
        home.selectTag();
        home.serchKeyWords("");
        this.keysword.value = "";
      }
    } else {
      home.selectTag();
      home.serchKeyWords("");
      this.keysword.value = "";
      this.setState({
        showTag: false,
      });
    }
  }
  showTags() {
    this.setState({
      showTag: true,
    });
  }
  changOne(val) {
    home.ChangeOnequestion(val);
    this.setState({
      selectData: val,
      detailId: val.storeQuestionEntity.id,
      showDetail: true,
    });
  }
  go() {
    this.props.history.push("/");
    home.serchKeyWords("");
    home.onequestion = "";
    home.selectTag();
  }
  searchNotes = (key, value) => {
    // 搜索键关键字变色
    var nWord = value; // 获取el表达式冲文本框输入的关键字
    var array = nWord.split(""); // 分割
    var dsa = key; // 获取全部商品
    for (var i = 0; i < array.length; i++) {
      // 创建表达式，匹配替换
      var reg = new RegExp("(" + array[i].replace(/,/, "|") + ")", "g");
      // 替换重新写入商品名， 匹配结果中对应的分组匹配结果
      dsa = dsa.replace(reg, "<span style='color:#f44336;'>$1</span>");
    }
    return dsa;
  };
  changeTag(val) {
    home.selectTag(val.name);
    let params = {
      page: this.state.page,
      size: this.state.size,
      question: this.state.value,
      type: 3,
      tagId: val.id,
    };
    findByQuestionPageable(params)
      .then((res) => {
        if (res.msg === "success") {
          let data = res.data.pageData.filter(
            (item) => item.storeQuestionEntity.isShow
          );
          home.setHotList(data);
        }
      })
      .catch((err) => {});
  }
  OnceShearch() {
    let params = {
      page: this.state.page,
      size: this.state.size,
      question: this.state.value,
      type: 3,
    };
    findByQuestionPageable(params)
      .then((res) => {
        if (res.msg === "success") {
          let data = res.data.pageData.filter(
            (item) => item.storeQuestionEntity.isShow
          );
          this.setState({
            dataArr: data,
            hasMore: true,
            refreshing: false,
            isLoading: true,
            dataSource: this.state.dataSource.cloneWithRows(data),
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages,
          });
        }
      })
      .catch((err) => {});
  }
  onEndReached = (event) => {
    this.setState({
      refreshing: true,
      isLoading: true,
      hasMore: false,
    });
    if (this.state.page + 1 < this.state.totalPages) {
      if (this.state.totalElements - this.state.dataArr.length >= 1) {
        this.setState({ page: this.state.page + 1 });
        this.getData();
      } else {
        this.setState({
          refreshing: true,
          isLoading: false,
          hasMore: false,
        });
        setTimeout(() => {
          this.setState({
            refreshing: false,
            isLoading: false,
            hasMore: false,
          });
        }, 1000);
      }
    } else {
      this.setState({
        refreshing: true,
        isLoading: false,
        hasMore: false,
      });
      setTimeout(() => {
        this.setState({
          refreshing: true,
          isLoading: false,
          hasMore: false,
        });
      }, 1000);
    }
  };
  showDetail() {
    this.setState({
      showDetail: true,
    });
  }
  close() {
    this.setState(
      {
        selectData: {},
        showDetail: false,
        page: 0,
      },
      () => {
        home.selectTag("");
        home.HotAll();
      }
    );
  }
  render() {
    const keyv = (key, value) => {
      //关键字变色
      var dsa = key; // 获取全部商品
      var re = new RegExp(value, "g"); //定义正则
      dsa = key.replace(re, `<span class="keyword">${value}</span>`);
      return <p dangerouslySetInnerHTML={{ __html: dsa }}></p>;
    };
    const row = (rowData) => {
      // 这里rowData,就是上面方法cloneWithRows的数组遍历的单条数据了，直接用就行
      return (
        <div
          className="question_search"
          onClick={() => {
            this.changOne(rowData);
          }}
        >
          <div>
            <i>
              <img src={searc_in} alt="" />
            </i>
            {keyv(rowData.storeQuestionEntity.question, home.searchKeyWord)}
          </div>
        </div>
      );
    };
    return (
      <div className="search">
        {home.isLoading ? <Loading /> : ""}
        <div className="search_header"></div>
        {/* 搜索主体 */}
        <div className="search_cnt">
          {/* 搜索框 */}
          <div className="search_in">
            <div>
              <i>
                <img src={searc_in} alt="" />
              </i>
              <input
                ref={(input) => (this.keysword = input)}
                type="text"
                placeholder="输入你想问的问题"
                onInput={(e) => {
                  this.serarchK(e);
                }}
                onFocus={() => {
                  this.showTags();
                }}
              />
              {this.state.value !== "" ? (
                <i
                  onClick={() => {
                    this.serarchK("");
                  }}
                >
                  <img src={kuaizhuang} alt="" />
                </i>
              ) : (
                ""
              )}
            </div>
            <span
              onClick={() => {
                this.go();
              }}
            >
              取消
            </span>
          </div>
          {/* 问题标签快速选择 */}
          {this.state.showTag ? (
            <div className="question_tags">
              {this.state.tags.map((item, index) => (
                <div
                  key={"tag" + index}
                  onClick={() => {
                    this.changeTag(item);
                  }}
                >
                  <span>{item.name}</span>
                </div>
              ))}
              <span></span>
            </div>
          ) : (
            ""
          )}
          {/* 问题总榜 */}
          {!this.state.isSearch ? (
            <div className="question_all">
              <span>{home.tagVal ? home.tagVal + "热榜" : "点击量热榜"}</span>
              {home.tagVal
                ? home.HotList.map((item, index) =>
                    item.storeTagEntity.name === home.tagVal ? (
                      <div
                        key={"hot" + index}
                        onClick={() => {
                          this.changOne(item);
                        }}
                      >
                        <i className="count">{1 + index}</i>
                        <p>{item.storeQuestionEntity.title}</p>
                        {item.storeQuestionEntity.isHot && index <= 2 ? (
                          <img className="hot" src={hot} alt="" />
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      ""
                    )
                  )
                : home.HotList.map((item, index) => (
                    <div
                      key={"hot" + index}
                      onClick={() => {
                        this.changOne(item);
                      }}
                    >
                      <i className="count">{1 + index}</i>
                      <p>{item.storeQuestionEntity.title}</p>
                      {item.storeQuestionEntity.isHot && index <= 2 ? (
                        <img className="hot" src={hot} alt="" />
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
            </div>
          ) : (
            ""
          )}
          {/* 搜索到的问题 */}
          {this.state.isSearch && this.state.dataArr.length !== 0 ? (
            <ListView
              ref={(el) => (this.search = el)}
              dataSource={this.state.dataSource}
              initialListSize={10}
              renderFooter={() =>
                this.state.refreshing ? (
                  <div className="footer">
                    {this.state.isLoading ? "加载中..." : "暂无更多数据"}
                  </div>
                ) : (
                  ""
                )
              }
              renderRow={row}
              onEndReachedThreshold={20}
              onEndReached={this.onEndReached.bind(this)}
              pageSize={1}
              style={{
                width: "98%",
                height: "calc(100vh - 3rem)",
                overflow: "auto",
                backgroundColor: "rgba(255,255,255,1)",
              }}
            />
          ) : (
            ""
          )}
          {/* 么有搜索结果 */}
          {this.state.isSearch && this.state.dataArr.length === 0 ? (
            <div className="no_search">
              <i>
                <img src={nosearch} alt="" />
              </i>
              <span>没有搜到相关结果</span>
            </div>
          ) : (
            ""
          )}
        </div>
        {/* 搜索结果查看 */}
        {this.state.showDetail ? (
          <Modal
            showModal={this.state.showDetail}
            groupData={this.state.selectData.storeGroupEntity}
            detailId={this.state.detailId}
            close={() => {
              this.close();
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default Search;
